<script setup lang="ts">
const items = [
  {
    title: 'Role Based Access Control (RBAC)',
    description: 'Otomatis membatasi akses sesuai jabatan',
    icon: 'material-symbols:connected-tv-outline'
  },
  {
    title: 'Insight Kinerja Staff',
    description: 'Lihat performa per individu, siapa paling produktif',
    icon: 'material-symbols:bar-chart'
  },
  {
    title: 'Terintegrasi Total',
    description: 'Satu sistem dengan COD, RMS dan Laporan Keuangan',
    icon: 'material-symbols:all-inclusive'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Bukan Sekedar Bagi Tugas Tapi Bangun Sistem Kepercayaan"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
